<template>
  <a-modal
      v-model:visible="visible"
      :title="$t('taskStream')"
  >
    <template #footer>
      <a-button type="primary">{{ $t("iKnow") }}</a-button>
    </template>
    <svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
         y="0px"
         viewBox="0 0 386.8 537.71" style="enable-background:new 0 0 467.12 676.58;" xml:space="preserve">
      <g>
    <g>
      <rect class="cls-3" x="131.58" y=".5" width="123.65" height="47"/>
      <text class="cls-1" transform="translate(165.4 19.81)"><tspan x="0" y="0">提出申请</tspan><tspan x="-10.97" y="18">Place O</tspan><tspan class="cls-8" x="39.58" y="18">r</tspan><tspan x="44.72" y="18">der</tspan></text>
    </g>
        <g>
      <rect class="cls-3" x="131.58" y="70.46" width="123.65" height="47"/>
          <text class="cls-2" transform="translate(165.4 89.66) scale(.97 1)"><tspan x="0" y="0">出具方案</tspan><tspan class="cls-10" x="-25.58" y="18">S</tspan><tspan x="-17.79" y="18">tra</tspan><tspan class="cls-13" x="1" y="18">t</tspan><tspan x="6.24" y="18">egy Design</tspan></text>
    </g>
        <g>
      <rect class="cls-3" x="55.41" y="140.42" width="275.99" height="47"/>
          <text class="cls-1" transform="translate(121.5 159.73)"><tspan x="0" y="0">sgRNA合成及分子克隆</tspan><tspan x="-55.81" y="18">sgRNA </tspan><tspan class="cls-7" x="-5.86" y="18">S</tspan><tspan x="1.87" y="18">ynthesis &amp; Molecular Cloning</tspan></text>
    </g>
        <g>
      <rect class="cls-3" x="41.3" y="210.37" width="304.2" height="47"/>
          <text class="cls-1" transform="translate(130.4 229.69)"><tspan x="0" y="0">显微注射及胚胎移植</tspan><tspan x="-78.2" y="18">Emb</tspan><tspan class="cls-15" x="-48.44" y="18">r</tspan><tspan class="cls-11" x="-42.49" y="18">y</tspan><tspan x="-35.15" y="18">os Mic</tspan><tspan class="cls-8" x="8.8" y="18">r</tspan><tspan x="13.95" y="18">oinjection &amp; </tspan><tspan class="cls-5" x="100.84" y="18">T</tspan><tspan x="107.55" y="18">ransplantation</tspan></text>
    </g>
        <g>
      <rect class="cls-3" x="75.69" y="280.33" width="235.43" height="47"/>
          <text class="cls-1" transform="translate(150.58 299.65)"><tspan x="0" y="0">F0代小鼠筛选</tspan><tspan x="-57.67" y="18">F0 Generation Mice Sc</tspan><tspan class="cls-8" x="92.35" y="18">r</tspan><tspan x="97.5" y="18">eening</tspan></text>
    </g>
        <g>
      <rect class="cls-3" x="75.69" y="350.29" width="235.43" height="47"/>
          <text class="cls-1" transform="translate(150.58 369.6)"><tspan x="0" y="0">F1代小鼠鉴定</tspan><tspan x="-64.01" y="18">F1 Generation Mice Genotyping</tspan></text>
    </g>
        <g>
      <rect class="cls-3" x="107.06" y="420.25" width="172.69" height="47"/>
          <text class="cls-1" transform="translate(165.4 439.56)"><tspan x="0" y="0">安排转运</tspan><tspan class="cls-9" x="-45.27" y="18">P</tspan><tspan x="-37.26" y="18">ositi</tspan><tspan class="cls-14" x="-9.21" y="18">v</tspan><tspan x="-1.96" y="18">e Mice Deli</tspan><tspan class="cls-14" x="72.7" y="18">v</tspan><tspan x="79.96" y="18">e</tspan><tspan class="cls-15" x="87.9" y="18">r</tspan><tspan x="93.86" y="18">y</tspan></text>
    </g>
        <g>
      <rect class="cls-3" x="131.58" y="490.21" width="123.65" height="47"/>
          <text class="cls-1" transform="translate(165.4 509.52)"><tspan x="0" y="0">确认完成</tspan><tspan x="-9" y="18">Comple</tspan><tspan class="cls-12" x="43" y="18">t</tspan><tspan x="48.1" y="18">ed</tspan></text>
    </g>
  </g>
      <text class="cls-1" transform="translate(316.6 365.06)"><tspan x="0" y="0">No</tspan></text>
      <text class="cls-1" transform="translate(51.04 295.32)"><tspan x="0" y="0">No</tspan></text>
      <text class="cls-1" transform="translate(160.86 344.72)"><tspan class="cls-6" x="0" y="0">Y</tspan><tspan x="7.12" y="0">es</tspan></text>
      <text class="cls-1" transform="translate(160.86 415.01)"><tspan class="cls-6" x="0" y="0">Y</tspan><tspan x="7.12" y="0">es</tspan></text>
      <g>
    <text class="cls-1" transform="translate(203.99 63.59)"><tspan x="0" y="0">3-5 days</tspan></text>
        <text class="cls-1" transform="translate(203.99 133.87)"><tspan x="0" y="0">2-4 </tspan><tspan class="cls-11" x="26.62" y="0">w</tspan><tspan x="37.6" y="0">eeks</tspan></text>
        <text class="cls-1" transform="translate(203.99 204.15)"><tspan x="0" y="0">2-3 </tspan><tspan class="cls-11" x="26.62" y="0">w</tspan><tspan x="37.6" y="0">eeks</tspan></text>
        <text class="cls-1" transform="translate(203.99 274.44)"><tspan x="0" y="0">5-8 </tspan><tspan class="cls-11" x="26.62" y="0">w</tspan><tspan x="37.6" y="0">eeks</tspan></text>
        <text class="cls-1" transform="translate(203.99 344.72)"><tspan x="0" y="0">10-12 </tspan><tspan class="cls-11" x="43.04" y="0">w</tspan><tspan x="54.02" y="0">eeks</tspan></text>
        <text class="cls-1" transform="translate(203.99 415.01)"><tspan x="0" y="0">2-4 </tspan><tspan class="cls-11" x="26.62" y="0">w</tspan><tspan x="37.6" y="0">eeks</tspan></text>
  </g>
      <g>
    <g>
      <line class="cls-4" x1="193.4" y1="64.77" x2="193.4" y2="47.87"/>
      <polygon points="197.39 63.6 193.4 70.51 189.41 63.6 197.39 63.6"/>
    </g>
        <g>
      <line class="cls-4" x1="193.4" y1="134.7" x2="193.4" y2="117.81"/>
          <polygon points="197.39 133.54 193.4 140.44 189.41 133.54 197.39 133.54"/>
    </g>
        <g>
      <line class="cls-4" x1="193.4" y1="204.64" x2="193.4" y2="187.75"/>
          <polygon points="197.39 203.47 193.4 210.38 189.41 203.47 197.39 203.47"/>
    </g>
        <g>
      <line class="cls-4" x1="193.4" y1="274.57" x2="193.4" y2="257.68"/>
          <polygon points="197.39 273.41 193.4 280.32 189.41 273.41 197.39 273.41"/>
    </g>
        <g>
      <line class="cls-4" x1="193.4" y1="344.51" x2="193.4" y2="327.62"/>
          <polygon points="197.39 343.34 193.4 350.25 189.41 343.34 197.39 343.34"/>
    </g>
        <g>
      <line class="cls-4" x1="193.4" y1="414.45" x2="193.4" y2="397.55"/>
          <polygon points="197.39 413.28 193.4 420.19 189.41 413.28 197.39 413.28"/>
    </g>
        <g>
      <line class="cls-4" x1="193.4" y1="484.38" x2="193.4" y2="467.49"/>
          <polygon points="197.39 483.21 193.4 490.12 189.41 483.21 197.39 483.21"/>
    </g>
  </g>
      <g>
    <g>
      <polyline class="cls-4" points="125.48 105.16 1 105.16 1 303.17 75.58 303.17"/>
      <polygon points="124.31 101.17 131.22 105.16 124.31 109.15 124.31 101.17"/>
    </g>
        <g>
      <polyline class="cls-4" points="351.46 240.25 385.8 240.25 385.8 373.13 311.31 373.13"/>
          <polygon points="352.63 244.23 345.72 240.25 352.63 236.26 352.63 244.23"/>
    </g>
        <g>
      <polyline class="cls-4" points="35.52 234.53 1 234.53 1 303.17 75.58 303.17"/>
          <polygon points="34.35 230.54 41.26 234.53 34.35 238.51 34.35 230.54"/>
    </g>
  </g>
</svg>

  </a-modal>
</template>

<script>
export default {
  name: "frontConfirm",
  data() {
    return {
      visible: true
    }
  }
}
</script>


<style scoped>
.cls-1 {
  font-size: 14px;
}

.cls-1, .cls-2 {
  font-family: MicrosoftYaHei, 'Microsoft YaHei';
}

.cls-2 {
  font-size: 14.37px;
}

.cls-3, .cls-4 {
  fill: none;
  stroke: #000;
  stroke-miterlimit: 10;
}

.cls-4 {
  stroke-width: 2px;
}

.cls-5 {
  letter-spacing: -.09em;
}

.cls-6 {
  letter-spacing: -.09em;
}

.cls-7 {
  letter-spacing: -.02em;
}

.cls-8 {
  letter-spacing: -.01em;
}

.cls-9 {
  letter-spacing: -.04em;
}

.cls-10 {
  letter-spacing: -.03em;
}

.cls-11 {
  letter-spacing: 0em;
}

.cls-12 {
  letter-spacing: 0em;
}

.cls-13 {
  letter-spacing: 0em;
}

.cls-14 {
  letter-spacing: 0em;
}

.cls-15 {
  letter-spacing: .04em;
}
</style>